module.exports = __webpack_public_path__ + "static/media/fechandoColetor.e9073ac7.jpg";